import { UI, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { CustomerDetailStackParamList } from '../../../../../../routes/types';
import { customerPrivatePensionContractedQuery } from '../../../../../../store/customerDetail/privatePension/selectors';
import { PrivatePensionContractedTabProps } from '../../constants';
import { PrivatePensionCard } from '../PrivatePensionCard';
import { PrivatePensionCardLoading } from '../PrivatePensionCardLoading';

export const PrivatePensionList: React.FC<PrivatePensionContractedTabProps> = ({
  setSelectedTab,
}) => {
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const { data, loading, error, refresher } = useRecoilQuery(
    customerPrivatePensionContractedQuery({ accountId: params.accountId })
  );

  if (loading) {
    return (
      <VStack space={Spacing['stack.xxs']}>
        {Array.from({ length: 3 }).map((_, i) => (
          <PrivatePensionCardLoading key={`private-pension-loading-${i}`} />
        ))}
      </VStack>
    );
  }

  if (error) {
    return <UI.ErrorBoundary onRefresh={refresher} />;
  }

  if (!data?.data.length) {
    return (
      <UI.ErrorBoundary
        errorIconOrIllustration="NotEmptyIllustration"
        errorTitle="Não existem contratos disponíveis"
        errorMessage="Este cliente não possui contratos disponíveis de previdência."
      />
    );
  }

  return (
    <VStack space={Spacing['stack.xxs']}>
      {data?.data.map((item, index) => (
        <PrivatePensionCard
          key={index}
          privatePensionContracted={item}
          setSelectedTab={setSelectedTab}
        />
      ))}
    </VStack>
  );
};
